var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTPortlet',{attrs:{"title":"My Services","id":"myServicesPortlet"}},[_c('template',{staticStyle:{"padding":"0"},slot:"body"},[_c('iframe',{staticStyle:{"border":"none"},attrs:{"id":"myServicesIframe","src":"http://status.bettercorp.co.za/","height":`${_vm.iframe.height}px`,"scrolling":"no"}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }